import { createContext, useContext } from 'react';

export const ConfettiArmedContext = createContext<boolean>(false);

export const useConfettiArmedContext = (): boolean => {
	return useContext(ConfettiArmedContext);
};
